export interface RequestError {
    message: string;
    code: number;
    errorCode: string;
    errorObject?: any;
}

export enum RequestErrorCode {
  NO_TSW_AVAILABILITY = 'NO_TSW_AVAILABILITY',
  MAX_HOLD_INVENTORY_LIMIT_REACHED = 'MAX_HOLD_INVENTORY_LIMIT_REACHED'
}
